var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SuawMainContent',{attrs:{"size":"large"}},[_c('h1',[_vm._v("Oops!")]),_c('p',[_vm._v(" We can't find the page you're looking for. "),_c('br'),_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_vm._v("Go Home")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }